export default {
    'this-team': 'هذا الفريق'
}